// Collections backing document surfaces (notes includes the templates variant).
// Probed by the empty-account fast path; FAST_PATH_TYPES in use-search.ts mirrors
// this list in search-type terms.
export const documentCollections = ['notes', 'userSources', 'blocks'] as const;

export type NoteVariant = 'notes' | 'templates';
